export const GENERAL_DISEASE = 'enfermedad general';
export const PARAFISCAL_CONTRIBUTIONS = 'Realizar Aportes Parafiscales en días de incapacidad.';
export const FULL_SALARY = 'Cotizar los días de incapacidad con el 100% del salario.';
export const HAS_FULL_PAY_DAYS = 'Cotizar los dos primeros días de la incapacidad con el 100%';
export const ENTER = 'Enter';
export const STRING_ERROR = 'confirm';
export const USER = 0;
export const NOVELTY = 0;
export const ERROR_NOVELTY = 'error with novelty date';
export const OBJECT = 'object';
export const FUNCTION = 'function';
